import React, { useEffect, useState } from 'react'
import { ReportMaxDateLimit, SettingsMenuList, SideBarMenuNames } from '../../core/Constants';
import { Box, Container, Stack } from '@mui/system';
import { Button, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import Loader from '../common/Loader';
import MessagePopup from '../common/MessagePopUp';
import SideBarMenuItems from '../SideBarMenuItems';
import ReportMenuItems from "../ReportMenuItems";
import Utils from '../../core/Utils';
import { connectToStore } from '../../data/store';
import CountryHelper from '../../core/CountryHelper';
import moment from "moment";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { getBusiness } from '../../data/localSettingsActions';
import VisibilityIcon from '@mui/icons-material/Visibility';

const ProductIntakesReport = () => {
  document.title = "Product Intakes Report";
  const [isLoading, setIsLoading] = useState(false);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [selectedDate, setSelectedDate] = useState([
    Utils.GetStartDate(),
    Utils.GetEndDate(),
  ]);
  const [localSettings, setLocalSettings] = useState(connectToStore());
  const [statementMethod, setStatementMethod] = useState("ProductIntakes");
  const [isAutomobileBusiness, setIsAutomobileBusiness] = useState(false);

  useEffect(() => {
    const business = getBusiness();
    setIsAutomobileBusiness(business.category == "Automobile");
  }, [])

  const handleSubmit = () => {
    setIsLoading(true);
    let url = "";
    if (statementMethod === "ProductIntakes") {
      url = "reports/GetProductIntakes?";
    } else if (statementMethod === "InventaryAgeing") {
      url = "reports/GetInventaryAgeing?"
    } else if (statementMethod === "ProductSales") {
      url = "reports/GetProductSales?"
    }

    let reportUrl =
      Utils.GetServiceUrl() +
      url +
      "branchId=" +
      localSettings.branch.branchId +
      "&businessId=" +
      localSettings.business.id +
      "&startDate=" +
      Utils.GetISODateTimeString(selectedDate[0]) +
      "&endDate=" +
      Utils.GetISODateTimeString(selectedDate[1]) +
      "&token=" +
      localSettings.token +
      "&culture=" +
      CountryHelper.GetAPICulture(localSettings.country.Culture);
    setIsLoading(false);
    window.open(reportUrl, "_blank");
  };

  const onDateChange = (date) => {
    if (!Utils.IsNullOrEmptyArray(date)) {
      var dateArray = [moment(date[0]), moment(date[1])];
      let dateDiff = dateArray[1].diff(dateArray[0], "days");
      if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
        setMsgText(
          "Please select a valid date range."
        );
        setMsgOpen(true);
      }
      else if (dateDiff > ReportMaxDateLimit) {
        setMsgText(
          "Please note that the maximum date range you can select is 366 days. You can choose any start date within the past 366 days, but the end date cannot exceed this limit."
        );
        setMsgOpen(true);
      }
      else {
        setSelectedDate(dateArray);
      }
    }
  };

  const handleMsgClose = () => {
    setMsgOpen(false);
  };




  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />
        <Box>
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.InvoiceReport} />
            <Grid xs={12} className="content-sec c-sec2">
              <Grid container direction="row" className="">
                <ReportMenuItems
                  selectedMenu={SettingsMenuList.BusinessReports.ProductReports}
                />
                <Grid xs={12} md={9}>
                  <Grid spacing={2} className="form-sec" paddingBottom="100px">
                    <Stack
                      alignSelf="center"
                      justifyContent="end"
                      direction="row"
                      flex="1"
                      className="card white-bg p-1 mb-1"
                    >
                      <Stack
                        direction="row"
                        spacing={1}
                        style={{ height: "100%" }}
                      >
                        {statementMethod !== "InventaryAgeing" && <DateRangePicker
                          showLeadingZeros={true}
                          onChange={onDateChange}
                          maxDate={new Date()}
                          value={selectedDate}
                          locale={CountryHelper.GetDateCulture(localSettings.country.Culture)}
                          clearIcon={null}
                          calendarIcon={
                            <CalendarMonthOutlinedIcon
                              style={{
                                "font-size": "24px",
                                "align-self": "center",
                                color: "#666666",
                              }}
                            />
                          }
                        />}

                        <Stack direction="row"
                          justifyContent="end">
                          <Button
                            className="btn btn-secondary"
                            variant="contained"
                            type="submit"
                            onClick={handleSubmit}
                          >
                            <VisibilityIcon /> &nbsp;
                            View / Download Statement
                          </Button>
                        </Stack>
                      </Stack>
                    </Stack>

                    <Grid className="card white-bg" padding={2}>
                      <Stack direction="row" className="font-size-14">
                        <RadioGroup
                          value={statementMethod}
                          onChange={(e) => setStatementMethod(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        >
                          <Stack direction="row">
                            <FormControlLabel
                              value={"ProductIntakes"}
                              control={<Radio />}
                              label="Product Intakes"
                            />
                            {isAutomobileBusiness && <FormControlLabel
                              value={"InventaryAgeing"}
                              control={<Radio />}
                              label="Inventory Ageing"
                            />}
                            {isAutomobileBusiness && <FormControlLabel
                              value={"ProductSales"}
                              control={<Radio />}
                              label="Product Sales"
                            />}
                          </Stack>
                        </RadioGroup>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>

              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Container>
  )
}

export default ProductIntakesReport